import { create } from 'zustand'
import { DEFAULT_CATALOG_FILTERS, type CatalogFilters } from '@/types/catalog'

export type MobileCatalogView = 'categories' | 'list' | 'detail'

interface CatalogState {
  selectedCategoryId: string
  selectedModelId: string | null
  mobileView: MobileCatalogView
  drawerOpen: boolean
  filters: CatalogFilters
  setSelectedCategoryId: (categoryId: string) => void
  selectModel: (modelId: string) => void
  clearSelectedModel: () => void
  setMobileView: (view: MobileCatalogView) => void
  openDrawer: () => void
  closeDrawer: () => void
  setFilters: (patch: Partial<CatalogFilters>) => void
  resetFilters: () => void
}

export const useCatalogStore = create<CatalogState>((set) => ({
  selectedCategoryId: '',
  selectedModelId: null,
  mobileView: 'categories',
  drawerOpen: false,
  filters: DEFAULT_CATALOG_FILTERS,
  setSelectedCategoryId: (categoryId) =>
    set({
      selectedCategoryId: categoryId,
      selectedModelId: null,
      drawerOpen: false,
    }),
  selectModel: (modelId) =>
    set({
      selectedModelId: modelId,
      mobileView: 'detail',
    }),
  clearSelectedModel: () => set({ selectedModelId: null }),
  setMobileView: (view) => set({ mobileView: view }),
  openDrawer: () => set({ drawerOpen: true }),
  closeDrawer: () => set({ drawerOpen: false }),
  setFilters: (patch) => set((state) => ({ filters: { ...state.filters, ...patch } })),
  resetFilters: () => set({ filters: DEFAULT_CATALOG_FILTERS }),
}))
